import { ComponentProps } from "react";
import { BoldText } from "./BoldText";
import { Interpolation, Theme, css } from "@emotion/react";

export const PageTitle = ({
  children,
  ...props
}: ComponentProps<typeof BoldText> & {
  css?: Interpolation<Theme>;
}) => {
  return (
    <BoldText
      css={css`
        margin-bottom: 24px;
      `}
      tag="h1"
      {...props}
    >
      {children}
    </BoldText>
  );
};
